
import XNumber from 'vux/src/components/x-number/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Radio from 'vux/src/components/radio/index.vue'

import { mapState } from "vuex";
import { go } from "./../../util/router";
import {
getShopingCartData,
getShopingCartList,
putDeleteCart,
PutBatchOrder,
getShoppingCartQty,
putOrders,
getOrderReasonList,
putAddMadeLossCart,
} from "@/service/index";
import { zdsCategory } from "./../../config/env";
import ZSelect from "@/components/Select";
export default {
data() {
return {
zdsCategory: zdsCategory,
Items: [],
isAll: false,
CartData: { TotalAmount: 0 },
inQty: 0,
outQty: 0,
ModifyMadeQty: 0,
totalAmount: 0,
TemReasonList: [],
ReasonList: [],
OutReasonList: [],
OutReasonList2: [],
OutReasonOptions: [],
OutReasonOptions2: [],
OrderReason: "",
ChangeOrderReason: "",
CashOrderReason: "",
Description: "",
isShowDesc: true,
show1: false,
show1_1: false,
show1_2: false,
ReasonTitle: "",


tabCur: 0, // 默认现货选中
cartTypeList: [
{
type: "XH",
name: "现货",
num: 0,
ProList: [],
isCheckAll: false,
isCheckNum: 0,
isCheckPrice: 0,
isCheckIds: [],
outQty: 0,
OrderReason: "",
ChangeOrderReason: "",
CashOrderReason: "",
remark: "",
},
{
type: "WW",
name: "委外",
num: 0,
ProList: [],
isCheckAll: false,
isCheckNum: 0,
isCheckPrice: 0,
isCheckIds: [],
outQty: 0,
OrderReason: "", //普通委外订单原因
ChangeOrderReason: "", //改款委外订单原因
CashOrderReason: "", //现货订单原因
remark: "",
},
],







bind_P: "",
};
},
directives: {
TransferDom,
},
components: {
XNumber,
ZSelect,
Group,
Cell,
XTextarea,
Tab,
TabItem,
Swiper,
SwiperItem,
PopupHeader,
Popup,
TransferDom,
XSwitch,
Radio,
},
created() {
this.OrderReasonList(); 
this.getShopingCartData(); 
},
watch: {
tabCur(val) {
console.log(val);
sessionStorage.setItem("cartTabCur", val);
},
},
mounted() {

let _P = localStorage.getItem("_P");
if (_P) {
this.bind_P = "?p=" + _P;
}
window.onscroll = null;
try {
let cartTabCur = sessionStorage.getItem("cartTabCur");
if (cartTabCur) {
this.tabCur = Number(cartTabCur);
}
} catch (e) {

}
},
methods: {
getShopingCartData() {
getShopingCartData((res) => {
console.log("===", JSON.parse(res.data));
let cartData = JSON.parse(res.data);
this.cartTypeList[0].num = cartData.BatchCount;
this.cartTypeList[1].num = cartData.MadeCount;
this.cartTypeList[0].ProList = []; 
this.cartTypeList[1].ProList = []; 


let SpotList = { Z009: [], Z00B: [], Others: [] };
cartData.Batchs.forEach((val) => {
val.cur = false;
val.otype = val.SaleType === 0 ? "XHQG" : "XHXP";
val.BigZDL = val.MARA_MTART;
if (val.MARA_MTART === "Z009" || val.MARA_MTART === "Z00B") {
SpotList[val.MARA_MTART].push(val);
} else {
SpotList["Others"].push(val);
}
});
console.log("SpotList", SpotList);
this.cartTypeList[0].SpotList = SpotList;


for (let i = 0; i < cartData.Mades.length; i++) {
cartData.Mades[i].cur = false;
this.cartTypeList[1].ProList.push(cartData.Mades[i]);
}
console.log(JSON.parse(JSON.stringify(this.cartTypeList)));
});
},
Calcul() {

for (let itemf of this.cartTypeList) {
itemf.isCheckNum = 0;
itemf.isCheckPrice = 0;
itemf.outQty = 0;
itemf.isCheckIds = [];

if (itemf.type === "XH") {

let checkList = [];
for (const key in itemf.SpotList) {
let isCur = itemf.SpotList[key].filter((c) => c.cur === true);
checkList.push(...isCur);
}
console.log("checkList", checkList);

for (let item of checkList) {
if (item.otype === "XHQG" && item.ExpandData.StockStatus === 0) {

itemf.isCheckNum++;
itemf.isCheckPrice += item.ExpandData.ZJSJE;
itemf.isCheckIds.push(item.OId);
}
if (item.otype === "XHXP") {

itemf.outQty += item.Qty;

console.log("------", item);
itemf.isCheckIds.push(item.OId);
}
}
}

if (itemf.type === "WW") {
let checkList = itemf.ProList.filter((c) => c.cur === true);
for (let item of checkList) {
itemf.isCheckNum += item.MadeQty + item.ModifyMadeQty;

itemf.outQty += item.ModifyMadeQty;
itemf.isCheckIds.push(item.OId);
if (item.BigZDL === "Z006") {
itemf.isCheckPrice +=
item.Price * item.MadeQty * Number(item.ZPJGG);
} else {
itemf.isCheckPrice += item.TotalAmount;
}
}
}
}
console.log(JSON.parse(JSON.stringify(this.cartTypeList)));
},
swiperChange(e) {
this.tabCur = e;
},
Ccheck(item, itemf) {
item.cur = !item.cur;

if (itemf.type === "XH") {

let isCurArr = [];
for (const key in itemf.SpotList) {
let isAll =
itemf.SpotList[key].filter((c) => c.cur === false).length === 0;
isCurArr.push(isAll);
}
itemf.isCheckAll = isCurArr.indexOf(false) === -1;
}

else if (itemf.type === "WW") {
itemf.isCheckAll =
!itemf.ProList.filter((c) => c.cur === false).length > 0;
this.Calcul();
}
this.$forceUpdate(); 
this.Calcul();
},
CdoCheckAll(itemf) {
if (itemf.isCheckAll) {
itemf.isCheckAll = false;
if (itemf.type === "XH") {
for (const key in itemf.SpotList) {
itemf.SpotList[key].forEach((it) => {
it.cur = false;
});
}
} else if (itemf.type === "WW") {
for (let it of itemf.ProList) {
it.cur = false;
}
}
} else {
itemf.isCheckAll = true;
if (itemf.type === "XH") {
for (const key in itemf.SpotList) {
itemf.SpotList[key].forEach((it) => {
it.cur = true;
});
}
} else if (itemf.type === "WW") {
for (let it of itemf.ProList) {
it.cur = true;
}
}
}
this.Calcul();
},
PutBatchOrder(itemf) {

PutBatchOrder(
{
BatchOids: itemf.isCheckIds,
Description: itemf.remark,
},
(result) => {

if (result.code === "1") {
let Data = JSON.parse(result.data);
if (Data.IsSuccess) {
this.showAlert(`<p class="red">${Data.Msg}<p>`, () => {
go("/order", this.$router);
});
} else {
this.showAlert(Data.Msg, () => {});
}
} else {
this.showAlert(result.msg, () => {});
}
}
);

},
SubmitOrder(itemf) {
console.log(JSON.parse(JSON.stringify(itemf)));

if (itemf.type === "XH") {
if (itemf.isCheckIds.length <= 0) {
this.showToast("请先选择需要购买的商品!");
return;
}




let isHasSeled = false;
let isHasXHQG = false;
for (let item of itemf.ProList) {
console.log(item.otype);
if (item.cur) {
if (item.otype === "XHQG") {
isHasXHQG = true;
if (item.StockStatus > 0) {
isHasSeled = true;
}
}
}
}
if (isHasXHQG) {
this.showConfirm(
"现货订单提交将为你分配锁定库存，请确认！",
null,
() => {
if (isHasSeled) {
this.showConfirm("部分批次已售，是否继续提交？", null, () => {
this.PutBatchOrder(itemf);
});
} else {
this.PutBatchOrder(itemf);
}
}
);
} else {
this.PutBatchOrder(itemf);
}
}
if (itemf.type === "WW") {
if (itemf.isCheckIds.length <= 0) {
this.showToast("请先选择需要购买的商品!");
document.documentElement.scrollTop = document.body.scrollTop =
document.body.scrollHeight;
return;
}
if (
itemf.isCheckNum > 0 &&
itemf.isCheckNum != itemf.outQty &&
!itemf.OrderReason
) {
this.show1_2 = false;
this.show1 = true;
this.show1_1 = true;
this.ReasonTitle = "普通委外";
return;
}
if (itemf.outQty > 0 && !itemf.ChangeOrderReason) {
this.show1_1 = false;
this.show1 = true;
this.show1_2 = true;
this.ReasonTitle = "改款委外";
return;
}
this.show1_1 = false;
this.show1 = false;
this.show1_2 = false;
putOrders(
{
OrderReason: itemf.OrderReason,
ChangeOrderReason: itemf.ChangeOrderReason,
Description: itemf.remark,
ShoppingCartOids: itemf.isCheckIds,
},
(result) => {
if (result.code === "1") {
if (
result.data !== null &&
String(result.data).indexOf("BizCode") > -1
) {
this.showAlert(result.msg, () => {});
} else {
this.showAlert("订单提交成功!", () => {

itemf.OrderReason = "";
itemf.ChangeOrderReason = "";
itemf.remark = "";
go("/order", this.$router);
});
}
} else {
this.showAlert(result.msg, () => {});
}
}
);
}
},

onOrderReason(val, itemf) {
itemf.OrderReason = val.idx;
},

onChangeOrderReason(val, itemf) {
itemf.ChangeOrderReason = val.idx;
},

onCashOrderReason(val, itemf) {
itemf.CashOrderReason = val.idx;
},

DeleteCartXH(itemf, type, index, item) {
let CartDetails = [];

if (type === 1) {
item.isDel = true;
CartDetails.push({
BigZDL: item.MARA_MTART,
EntriesOids: [{ Oid: item.OId }],
});
}


if (type === 99) {
let checkList = [];
for (const key in itemf.SpotList) {
let isCur = itemf.SpotList[key].filter((c) => c.cur === true);
checkList.push(...isCur);
}
if (checkList.length <= 0) {
this.showToast("请先选择需要删除的商品！");
return;
}

let grouped = {};
checkList.forEach((x) => {
let value = x["MARA_MTART"];
grouped[value] = grouped[value] || [];
grouped[value].push(x);
});

Object.keys(grouped).forEach((x) => {
CartDetails.push({
BigZDL: x,
EntriesOids: [
...grouped[x].map((item) => {
return {
Oid: item.OId,
};
}),
],
});
});
}
let pData = {
CartDetails: CartDetails,
};

putDeleteCart(pData, (result) => {
if (result.code === "1") {
let res = JSON.parse(result.data);
if (res.IsSuccess) {
this.getShopingCartData(); 


















}
}
});
},

DeleteCart(itemf, type, index) {
let CartDetails = [];

if (type === 1) {
CartDetails.push({
BigZDL: itemf.ProList[index].BigZDL,
CarOid: itemf.ProList[index].OId,
EntriesOids: [],
});
}

if (type === 99) {
let checkList = itemf.ProList.filter((c) => c.cur === true);
if (checkList.length <= 0) {
this.showToast("请先选择需要删除的商品！");
return;
}
for (let item of checkList) {
CartDetails.push({
BigZDL: item.BigZDL,
CarOid: item.OId,
EntriesOids: [],
});
}
}
let pData = {
CartDetails: CartDetails,
};



putDeleteCart(pData, (result) => {
if (result.code === "1") {
let res = JSON.parse(result.data);
if (res.IsSuccess) {

if (type === 1) {
itemf.ProList.splice(index, 1);
this.cartTypeList[0].num--;
}
if (type === 99) {
let unCheckList = itemf.ProList.filter((c) => c.cur === false);
itemf.ProList = unCheckList;
}
this.cartTypeList[0].num = 0;
this.cartTypeList[1].num = 0;
for (let i = 0; i < this.cartTypeList[0].ProList.length; i++) {
this.cartTypeList[0].num++;
}
for (let i = 0; i < this.cartTypeList[1].ProList.length; i++) {
this.cartTypeList[1].num +=
this.cartTypeList[1].ProList[i].MadeQty +
this.cartTypeList[1].ProList[i].ModifyMadeQty;
}
this.Calcul();
}
}
});
},

doCheckAll() {
if (this.isAll) {
this.isAll = false;
for (let item of this.Items) {
item.cur = false;
for (let it of item.children) {
it.cur = false;
}
}
} else {
this.isAll = true;
for (let item of this.Items) {
item.cur = true;
for (let it of item.children) {
it.cur = true;
}
}
}
this.doQty();
},
checkAll(item, idx) {
console.log(idx);
if (item.cur) {
item.cur = false;
this.isAll = false;
for (let it of item.children) {
it.cur = false;
}
} else {
item.cur = true;
for (let it of item.children) {
it.cur = true;
}
this.isAll = !this.Items.filter((c) => c.cur === false).length > 0;
}
this.doQty();
},
check(item, it) {
if (it.cur) {
item.cur = false;
it.cur = false;
this.isAll = false;
} else {
it.cur = true;
let isT = true;
for (let it of item.children) {
if (it.cur === false) {
isT = false;
}
}
item.cur = isT;
this.isAll = !this.Items.filter((c) => c.cur === false).length > 0;
}
this.doQty();
},
doQty() {
this.inQty = 0;
this.outQty = 0;
this.totalAmount = 0;
this.ModifyMadeQty = 0;
for (let item of this.Items) {
if (item.num === "Z006") {
let ls = item.children.filter((c) => c.cur === true);
for (let it of ls) {
this.inQty += it.inQty;
this.outQty += it.outQty;
this.totalAmount += it.Price * it.outQty * it.ZPJGG;
}
} else {
let ls = item.children.filter((c) => c.cur === true);
for (let it of ls) {
this.inQty += it.inQty;
this.outQty += it.outQty;
this.totalAmount += it.TotalAmount;
this.ModifyMadeQty += it.ModifyMadeQty;
}
}
}
this.GetOrderReasonList();
},
del() {
let vm = this;
let CartDetails = [];
for (let i = 0; i < vm.Items.length; i++) {
let childs = vm.Items[i].children;
let _Items2 = childs.filter((c) => c.cur === true);
for (let item of _Items2) {
CartDetails.push({
BigZDL: vm.Items[i].num,
CarOid: item.oid,
EntriesOids: [],
});
}
}
let pData = {
CartDetails: CartDetails,
};
console.log(JSON.stringify(pData));
putDeleteCart(pData, (result) => {
if (result.code === "1") {
let res = JSON.parse(result.data);
if (res.IsSuccess) {
let IsT = true;
for (let i = 0; i < vm.Items.length; i++) {
let childs = vm.Items[i].children;
let _Items = childs.filter((c) => c.cur === false);
vm.Items[i].children = _Items;
if (_Items.length > 0) {
IsT = false;
}
vm.doQty();
}
if (IsT) {
vm.Items = [];
}
vm.CartData = res.CartTotal;
}
}
});
},
putAddMadeLossCart(id, qty) {
let vm = this;
let pData = {
CommodityOid: id,
Qty: qty,
};
putAddMadeLossCart(pData, (result) => {
if (result.code === "1") {


this.Calcul();
}
});
},
plus_minus(item, val) {},
getShopCartList() {
let vm = this;
vm.Items = [];
getShopingCartList((result) => {
if (result.code === "1") {
let List = JSON.parse(result.data);
console.log(List);
for (let item of List) {
item.cur = false;
switch (String(item.BigZDL)) {
case zdsCategory.ZSQ:
item.name = "镶嵌类";
break;
case zdsCategory.ZSJ:
item.name = "素金类";
break;
case zdsCategory.ZYHP:
item.name = "易耗品";
break;
default:
item.name = "镶嵌类";
break;
}
let CartDetails = [];
for (let it of item.CartDetails) {
CartDetails.push({
oid: it.OId,
cOid: it.CommodityOid,
name: it.CommodityName,
cur: false,
img: it.PhotoUrl,
num: it.CommodityNumber,
inQty: it.SpotQty,
outQty: it.MadeQty,
ModifyMadeQty: it.ModifyMadeQty,
ZPLMC: it.ZPLMC,
TotalAmount: it.TotalAmount,
Price: it.Price,
ZPJGG: Number(it.ZPJGG) > 0 ? Number(it.ZPJGG) : 1,
});
}
vm.Items.push({
name: item.name,
num: item.BigZDL,
cur: false,
children: CartDetails,
showList: false,
});
}
}
});
},
OrderReasonList() {
let vm = this;
getOrderReasonList((result) => {
if (result.code === "1") {
let ls = JSON.parse(result.data);
vm.TemReasonList = ls;
vm.OutReasonList = [
{
oid: "",
name: "",
},
];
vm.OutReasonList2 = [
{
oid: "",
name: "",
},
];
vm.ReasonList = [
{
oid: "",
name: "",
},
];
let maps = ls.filter((c) => c.ReasonType === "10");
for (let item of maps) {
vm.OutReasonList.push({
oid: item.ReasonOid,
name: item.Reason,
});
vm.OutReasonList2.push({
oid: item.ReasonOid,
name: item.Reason,
});
}
let maps2 = ls.filter((c) => c.ReasonType === "20");
for (let item of maps2) {
vm.ReasonList.push({
oid: item.ReasonOid,
name: item.Reason,
});
}
vm.OutReasonOptions = vm.OutReasonList.map((x) => {
return { key: x.oid, value: x.name };
});
vm.OutReasonOptions2 = vm.OutReasonList2.map((x) => {
return { key: x.oid, value: x.name };
});
}
});
},
GetOrderReasonList() {
let vm = this;
let inQty = 0;
let outQty = 0;

for (let i = 0; i < vm.Items.length; i++) {
let childs = vm.Items[i].children;
let _Items2 = childs.filter((c) => c.cur === true);
for (let it of _Items2) {
inQty += it.inQty;
outQty += it.outQty;
}
}
if (inQty > 0 && outQty > 0) {

vm.isShowDesc = true;
} else if (inQty > 0) {

vm.Description = "";
vm.isShowDesc = true;
} else {

vm.isShowDesc = true;
}
if (inQty === 0 && outQty === 0) {
vm.isShowDesc = false;
}




},
putDeleteCart() {
let vm = this;
let pData = {
CartDetails: [
{
BigZDL: vm.Detail.MARA_MTART,
CommodityOid: vm.Detail.OId,
Qty: vm.Detail.Qty,
},
],
};
putDeleteCart(pData, (result) => {
if (result.code === "1") {
vm.showAlert("");
}
});
},
getShopCartQty() {
let vm = this;
getShoppingCartQty((result) => {
if (result.code === "1") {
vm.CartData = JSON.parse(result.data);
}
});
},
putOrders() {
let vm = this;
let pData = {
OrderReason: vm.OrderReason,
ChangeOrderReason: vm.ChangeOrderReason,
CashOrderReason: vm.CashOrderReason,
Description: vm.Description,
ShoppingCartOids: [],
};
let inQty = 0;
let outQty = 0;
for (let i = 0; i < vm.Items.length; i++) {
let childs = vm.Items[i].children;
let _Items2 = childs.filter((c) => c.cur === true);
for (let it of _Items2) {
pData.ShoppingCartOids.push(it.oid);
inQty += it.inQty;
if (
vm.Items[i].num === zdsCategory.ZSQ ||
vm.Items[i].num === zdsCategory.ZSJ
) {
outQty += it.outQty;
}
}
}
if (pData.ShoppingCartOids.length <= 0) {
vm.showToast("请先选择需要购买的商品!");
return;
}
if (outQty > 0 && pData.OrderReason === "") {
this.showToast("请选择普通委外订单原因");
document.documentElement.scrollTop = document.body.scrollTop =
document.body.scrollHeight;
return;
}
if (this.ModifyMadeQty > 0 && pData.ChangeOrderReason === "") {
this.showToast("请选择改款委外订单原因");
document.documentElement.scrollTop = document.body.scrollTop =
document.body.scrollHeight;
return;
}
if (inQty > 0) {
if (pData.CashOrderReason === "") {
this.showToast("请选择现货订单原因");
document.documentElement.scrollTop = document.body.scrollTop =
document.body.scrollHeight;
return;
}
this.showConfirm(
"现货订单提交将为你分配锁定库存，请确认！",
null,
() => {
putOrders(pData, (result) => {
if (result.code === "1") {
if (
result.data !== null &&
String(result.data).indexOf("BizCode") > -1
) {
vm.showAlert(result.msg, () => {});
} else {
vm.showAlert("提交成功!", () => {
go("/order", this.$router);
});
}
} else {
vm.showAlert(result.msg, () => {});
}
});
}
);
} else {
putOrders(pData, (result) => {
if (result.code === "1") {
vm.showAlert("提交成功!", () => {
go("/order", this.$router);
});
} else {
vm.showAlert(result.msg, () => {});
}
});
}
},
doDetail(idx, id, type, cid) {
console.log(idx, id, type, cid);

switch (idx) {
case 0:
go("/shopbatch/" + cid + "/" + id, this.$router);
break;
case 1:
go("/outbatch/" + type + "/" + cid + "/" + id, this.$router);
break;
case 2:
go("/shopcart", this.$router);
break;
case 3:
go("/shopmatchs/" + type + "/" + cid + "/" + id, this.$router);
break;
default:
break;
}
},
changeQty(val) {
console.log(val);
this.putAddMadeLossCart(val.CommodityOid, val.MadeQty);
},
onOutResultChange(val) {
this.OrderReason = val.idx;
},
onOutResultChange2(val) {
this.ChangeOrderReason = val.idx;
},
onResultChange(val) {
this.CashOrderReason = val.idx;
},
},
computed: {
...mapState({
route: (state) => state.route,
path: (state) => state.route.path,
}),
},
};



// WEBPACK FOOTER //
// ./src/page/shopcart/shopcart.vue